import css from './FormData.module.css';

function FormData({children}) {
    return <div className={css.formData}>
        {children.map(x => x)}
        </div>;
}

export default FormData;
